import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance, formatRelative, isToday } from 'date-fns';
import enGB from 'date-fns/locale/en-GB';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

// https://date-fns.org/docs/I18n-Contribution-Guide#formatrelative
// https://github.com/date-fns/date-fns/blob/master/src/locale/en-US/_lib/formatRelative/index.js
// https://github.com/date-fns/date-fns/issues/1218
// https://stackoverflow.com/questions/47244216/how-to-customize-date-fnss-formatrelative
const formatRelativeLocale = {
    lastWeek: "'Last' eeee",
    yesterday: "'Yesterday'",
    today: "'Today at' p",
    tomorrow: "'Tomorrow'",
    nextWeek: "'Next' eeee",
    other: 'yyyy-MM-dd' // should be retrieved from locale once user settings service has been merged
};

const locale = {
    ...enGB,
    formatRelative: (token) => formatRelativeLocale[token]
};
@Pipe({
    name: 'dateRelative',
    standalone: true
})
export class DateRelativePipe implements PipeTransform {
    transform(date: Date): Observable<string> {
        // if date is a string, convert it to a Date object
        if (typeof date === 'string') {
            date = new Date(date);
        }
        // date is today, update every minute otherwise every hour
        const updateEvery = isToday(date) ? 1000 * 60 : 1000 * 60 * 60;
        return timer(0, updateEvery).pipe(
            map(() => {
                if (!date) {
                    return '';
                } else if (isToday(date)) {
                    return formatDistance(date, new Date(), {
                        addSuffix: true,
                        locale
                    });
                } else {
                    return formatRelative(date, new Date(), { locale });
                }
            })
        );
    }
}
